var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssignIcon = function SvgAssignIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-182.000000, -237.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.181818,217 L161.818182,217 C160.809091,217 160,217.791111 160,218.777778 L160,229.444444 C160,230.422222 160.809091,231.222222 161.818182,231.222222 L166.363636,231.222222 L166.363636,233 L173.636364,233 L173.636364,231.222222 L178.181818,231.222222 C179.181818,231.222222 179.990909,230.422222 179.990909,229.444444 L180,218.777778 C180,217.791111 179.181818,217 178.181818,217 L178.181818,217 Z M178.181818,229.444444 L161.818182,229.444444 L161.818182,218.777778 L178.181818,218.777778 L178.181818,229.444444 L178.181818,229.444444 Z M173.636364,223.222222 L173.636364,225 L170.909091,225 L170.909091,227.666667 L169.090909,227.666667 L169.090909,225 L166.363636,225 L166.363636,223.222222 L169.090909,223.222222 L169.090909,220.555556 L170.909091,220.555556 L170.909091,223.222222 L173.636364,223.222222 L173.636364,223.222222 Z",
    id: "Assign-Co-host"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssignIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assign-icon.a0fe0ab3.svg";
export { ForwardRef as ReactComponent };